import { render } from "./USER_MENTION.vue?vue&type=template&id=1ac0e089&ts=true"
import script from "./USER_MENTION.vue?vue&type=script&lang=ts"
export * from "./USER_MENTION.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__